export default __webpack_public_path__ + "src/images/packages/gocheganas-lodge/5abfa3c2b08045a02815c4ff07ebd3d7-3.jpeg";